import axios from '@src/utils/axios'

const module = 'user'
const axiosInstance = axios(false);

export default {
  'dashboard': () => axiosInstance.get('/user/dashboard'),

  'pagination': (ctx, data) => axiosInstance.get('/user/paginate', {params:data}),
  'paginate_source_candidate': (ctx, data) => axiosInstance.get('/user/paginate_source_candidate', {params:data}),
  'sync_source_candidate': (ctx, data) => axiosInstance.get(`vincere/get_source_candidate`, data),
  'create': (ctx, data) => axiosInstance.post('/user', data),
  'update': (ctx, data) => axiosInstance.put('/user', data),
  'invite': (ctx, data) => axiosInstance.post('/user/invite', data),
  'reset': (ctx, data) => axiosInstance.post('/user/reset', data),
  'updateNewPassword': (ctx, data) => axiosInstance.post('/user/update_new_password', data),
  'find': (ctx, data) => axiosInstance.get('/user/' + data.id),
  'findUser': (ctx, data) => axiosInstance.get('/user/find_user/' + data.id),
  'candidate_source': () => axiosInstance.get(`/${module}/candidate_source`),
  'companies': () => axiosInstance.get('/user/find_companies'),
  'checkResetToken': (ctx, data) => axiosInstance.get('/user/get_by_token/' + data.token, data),

  'findByToken': (ctx, data) => axiosInstance.get('/invitation/get_data', {params:data}),
  'step_1': (ctx, data) => axiosInstance.post('/invitation/step_1', data),
  'step_2': (ctx, data) => axiosInstance.post('/invitation/step_2', data),
  'step_3': (ctx, data) => axiosInstance.post('/invitation/step_3', data),
  'step_4': (ctx, data) => axiosInstance.post('/invitation/step_4', data),
  'finalize': (ctx, data) => axiosInstance.post('/invitation/finalize', data),
  'total_pending': () => axiosInstance.get('/invitation/total_pending'),
  'parseCV': (ctx, data) => axiosInstance.post('/invitation/parse_cv', data),

  'createNote': (ctx, data) => axiosInstance.post(`/${module}/create_note`, data),

  'prospectParseCV': (ctx, data) => axiosInstance.post('/prospect/parse_cv', data),
  'prospectUploadCVs': (ctx, data) => axiosInstance.post('/prospect/upload_cvs', data),
  'prospectStep_1': (ctx, data) => axiosInstance.post('/prospect/step_1', data),
  'prospectStep_2': (ctx, data) => axiosInstance.post('/prospect/step_2', data),
  'prospectStep_3': (ctx, data) => axiosInstance.post('/prospect/step_3', data),
  'prospectStep_4': (ctx, data) => axiosInstance.post('/prospect/step_4', data),

  'uploadAvatar': (ctx, data) => axiosInstance.post(`/${module}/upload_avatar`, data),
  'uploadAttachment' : (ctx, data) => axiosInstance.post(`/${module}/upload_attachment`, data),

  'downloadAttachment' : (ctx, data) => axiosInstance.get(`/${module}/download_attachment`, {params:data}),
  'deleteAttachment' : (ctx, data) => axiosInstance.delete(`/${module}/delete_attachment/` + data.id),

  'changePassword' : (ctx, data) => axiosInstance.post(`/${module}/change_password/` + data.id, data),
  'activate':  (ctx, data) =>  axiosInstance.post(`/${module}/activate`, data),
  'updateLanguage':  (ctx, data) =>  axiosInstance.put(`/${module}/language`, data)
}